import { render, staticRenderFns } from "./serves.vue?vue&type=template&id=bbad6eb8&scoped=true&"
import script from "./serves.vue?vue&type=script&lang=js&"
export * from "./serves.vue?vue&type=script&lang=js&"
import style0 from "./serves.vue?vue&type=style&index=0&id=bbad6eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbad6eb8",
  null
  
)

export default component.exports